import { render, staticRenderFns } from "./bodyContentComponent.vue?vue&type=template&id=a047fdc2&scoped=true&"
import script from "./bodyContentComponent.vue?vue&type=script&lang=js&"
export * from "./bodyContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./bodyContentComponent.vue?vue&type=style&index=0&id=a047fdc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a047fdc2",
  null
  
)

export default component.exports